import React,{useState} from 'react'
import '../App.css'
import Avatar from '../img/addAvatar.png'
import {auth, db, provider, storage} from '../config/firebase'
import {signInWithPopup, createUserWithEmailAndPassword,updateProfile} from 'firebase/auth'
import { doc, setDoc } from "firebase/firestore"; 
import { useNavigate, Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
const Signup = () => {
   const [displayName, setdisplayName] = useState("")
   const [email, setemail] = useState("")
   const [password, setpassword] = useState("")
   const [cpassword, setcpassword] = useState("")
   const [file, setfile] = useState()
   const navigate = useNavigate();

   const signinwithGoogle = async () =>{
    const result= await signInWithPopup(auth, provider);
     await setDoc(doc(db, "users", result.user.uid), {
      uid: result.user.uid,
      displayName : result.user.displayName.split(" ")[0],
      email: result.user.email,
      photoURL: result.user.photoURL
    });

    await setDoc(doc(db,"userChats", result.user.uid),{});
    toast.success("Account created successfully!")
    navigate("/")
    console.log(displayName.split(" ")[0])

    await updateProfile(result.user,{
      displayName:result.user.displayName.split(" ")[0],
      photoURL: result.user.photoURL
    })
    console.log(result)

    
    
   }

   const handleregister = async (e) =>{
     e.preventDefault(); 
     if(password !== cpassword){
      toast.error("Password doesn't match")
     }
    
     try{
     const res = await createUserWithEmailAndPassword(auth, email, password);
      
     


const storageRef =  ref(storage, displayName);

await uploadBytesResumable(storageRef, file).then(() => {
  getDownloadURL(storageRef).then(async (downloadURL) => {
  try {
     
     toast.success("Avatar Updated Successfully")
    
      await updateProfile(res.user,{
        displayName,
        photoURL: downloadURL,
      });
   

    toast.success("Account created successfully!")
    navigate("/")
     await setDoc(doc(db, "users", res.user.uid), {
      uid: res.user.uid,
      displayName,
      email,
      photoURL:downloadURL,
    });
     
    await setDoc(doc(db,"userChats", res.user.uid),{});
  }
    catch(err) {
      toast.error(err.message)
    }
  
  });
});  
    

     } catch(err) {
    
    toast.error(err.message)
  };

    // navigate("/")
  };

  return (
    <>
    <div>
      <div className='login-cont'>
      <div className='card'>
        <h2 style={{textAlign:"center"}}>Welcome 👋</h2>
        <form className='login-form' onSubmit={handleregister}>
        <input type='text' value={displayName} placeholder='Full name' onChange={(e) =>{ setdisplayName(e.target.value)}} className='login-input' required/>
        <input type='email' value={email} placeholder='Email' onChange={(e) =>{ setemail(e.target.value)}} className='login-input' required/>
        <input type='password' value={password}   placeholder='Password' onChange={(e) =>{ setpassword(e.target.value)}} className='login-input' required/>
        <input type='password' value={cpassword}   placeholder='Confirm Password' onChange={(e) =>{ setcpassword(e.target.value)}} className='login-input' required/>
        <input required style={{ display: "none" }} type="file" id="file" onChange={(e) =>{setfile(e.target.files[0])}}/>
          <label htmlFor="file" className='ava-inp'>
            <img src={Avatar} alt="" />
            <span>Add an avatar</span>
          </label>
        <div>
        <button className="btn btn-outline-success" >Sign Up</button>
        </div>
        </form>
        <div className='google-login'>
         <h3 style={{font:"1.6rem", color:"green"}}>OR</h3>
         <p>Signup with Google</p>
         <button onClick={signinwithGoogle}>Signup with Google</button>
         </div> 
         <span className='alt-links'>Already have an account? <Link to='/login'>Login in</Link></span>
        {/* </div>  */}
      </div>
    </div>
    </div>
    
    </>
  )
}

export default Signup